

















































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { AppModule } from "@/store/modules/app"
import { ImageClipper } from "@/utils/imageClipper";
import { SingleAssetUsage, AssetFile, AssetsModule } from "@/store/modules/asset";
import { RailwayModule } from '@/store/modules/railway';
import { ToolbarModule } from "@/store/modules/toolbar"

@Component({
  name: "railway-preview"
})

export default class RailwayPreview extends Vue {
  private flipcounter: number = 0
  private mobileFlipCounter: number = 1
  private boxCount: number = 0
  private currentPosMobile: number = 1
  private mobilePageWidth: number = 465
  private pageIndex = [3,1]
  private railwayImageClipper = ImageClipper.getImageClipper(false, 1)
  private scaleFac = (4.7/6.6) * (465/370)
  private scaleTitle = 465/400
  private railwayImageUrl = ""

  get title() {
    return RailwayModule.title
  }

  get devotionText() {
    return RailwayModule.dedication.text
  }

  get devotionTextSize() {
    return RailwayModule.dedication.size + "px";
  }

  get show() {
    return AppModule.showPreview
  }

  get railwayAssetId() {
    return RailwayModule.railwayAssetId
  }

  get railwayImageBoundingBox() {
    return RailwayModule.railwayImageBoundingBox
  }

  get railwayImageRotation() {
    return RailwayModule.railwayImageRotation
  }

  private evaluateRailwayImage(): {
    usage?: SingleAssetUsage;
    asset?: AssetFile;
  } {
    let asset;
    let usage;
    if (AppModule.currentStepIndex !== 1) {
      let assetId = RailwayModule.railwayAssetId;
      if (assetId >= 0) {
        for (let currentAsset of AssetsModule.assets) {
          if (currentAsset.assetId === assetId) {
            asset = currentAsset;
            break;
          }
        }
      }
      if (asset && AppModule.steps[1].usageName) {
        usage = asset.usage[AppModule.steps[1].usageName];
        if (usage) {
          return { usage: usage as SingleAssetUsage, asset };
        }
      }
    } else {
      let asset: AssetFile | undefined = AssetsModule.selected;
      if (asset) {
        let center = [...ToolbarModule.center];
        let usage: SingleAssetUsage = {
          rotation: ToolbarModule.rotation,
          zoom: ToolbarModule.zoom,
          center: center as [number, number]
        };
        return { usage, asset };
      }
    }
    return {};
  }

  forward() {
    this.flipcounter++
    if (this.currentPosMobile > 1) {
      this.currentPosMobile--
      var mobileContainer = this.$refs.mobileContainer as HTMLElement
      var translate = (this.boxCount * 2 - this.currentPosMobile) * (this.mobilePageWidth)
      mobileContainer.style.transform = "translateX(-" + translate + "px)"
    }
    if (this.currentPosMobile == 1) {
      (this.$refs.forward as HTMLElement).style.opacity = "0"
    }
    (this.$refs.back as HTMLElement).style.opacity = "100"
  }

  back() {
    if (this.currentPosMobile <= this.boxCount * 2 - 1) {
      this.currentPosMobile++
      var mobileContainer = this.$refs.mobileContainer as HTMLElement
      var translate = 0
      if (this.currentPosMobile == this.boxCount * 2) {
        translate = 0
      } else {
        translate = (this.boxCount * 2 - this.currentPosMobile) * (this.mobilePageWidth)
      }
      mobileContainer.style.transform = "translateX(-" + translate + "px)"
    }
    if (this.currentPosMobile == this.boxCount * 2) {
      (this.$refs.back as HTMLElement).style.opacity = "0"
    }
    (this.$refs.forward as HTMLElement).style.opacity = "100"
  }

  onClose() {
    this.init();
    (this.$refs.mobileContainer as HTMLElement).style.transform = "translate(0)";
    AppModule.SetShowPreview(false);
    (document.body as HTMLElement).style.overflow="hidden"
  }

  mounted() {
    this.init()
    window.addEventListener("resize", this.resized)
    this.resized()
    this.setPreviewAsset()
  }

  init() {
    this.boxCount = this.pageIndex.length
    this.currentPosMobile = this.boxCount * 2
    for (let i: number = 0; i < this.pageIndex.length; i++) {
      let translatex: number = i *  2 * (this.mobilePageWidth) + (this.mobilePageWidth);
      (this.$refs.mobilePage as HTMLElement[])[
        this.boxCount - 1 - i
      ].style.transform = "translateX(" + translatex + "px)";
    }
    (this.$refs.forward as HTMLElement).style.opacity = "100";
    (this.$refs.back as HTMLElement).style.opacity = "0";

  }

  resized() {
    let width = window.innerWidth
    let height = window.innerHeight
    let scale = 1
    if (width < 1144) {
      if (width > height) {
        scale = height / 650
      } else {
        scale = width / 600
      }
    }
    (this.$refs.container as HTMLElement).style.transform =
      "scale(" + scale + ")";
  }

  setPreviewAsset() {
    let { usage: railwayUsage, asset: railwayAsset } = this.evaluateRailwayImage();
    if (railwayAsset && railwayUsage) {
      this.railwayImageUrl = railwayAsset.url;
      this.railwayImageClipper.initializeUsage(railwayUsage, railwayAsset.rect);
    } else {
      this.railwayImageUrl = "";
    }
  }

  @Watch("railwayAssetId")
  railwayAssetIdChanged() {
    this.setPreviewAsset()
  }

  @Watch("railwayImageBoundingBox")
  railwayImageBoundingBoxChanged() {
    this.setPreviewAsset()
  }

  @Watch("railwayImageRotation")
  railwaImageRotationChanged() {
    this.setPreviewAsset()
  }
}
